// extracted by mini-css-extract-plugin
export default {"SignUp":"ThankYou_SignUp__Fnj3P","Border":"ThankYou_Border__LN7pR","InputClass":"ThankYou_InputClass__5-J9y","Button":"ThankYou_Button__woRFy","Image":"ThankYou_Image__KIiZV"};